/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { alias } from '@ember/object/computed';
import { action } from '@ember/object';
import { service } from '@ember/service';
import JournalStatus from 'linced-app/enums/xero-journal-status';
import config from 'linced-app/config/environment';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class XeroBatchesController extends Controller {
  @service
  session;

  @service
  fetch;

  @service
  toaster;

  @service
  options;

  JournalStatus = JournalStatus;

  @alias('session.school.name')
  schoolName;

  @optionAlias('finance:xero:piaLedgerCode')
  piaLedgerCode;

  @action
  resetTransactions(batch) {
    let url = `${config.APP.apiHost}/finance/${config.APP.apiPath}/transactions/:bulkUpdateTxnXeroBatch`;
    let data = {
      schoolId: this.session.activeSchool,
      xeroBatchNo: parseInt(batch.batchNo),
      resetBatch: true,
    };
    return this.fetch
      .post(url, { data })
      .then(() => {
        batch.set('hasBeenReset', true);
        batch
          .save()
          .then(() => {
            this.toaster.success(
              `Batch Number ${batch.batchNo} has been reset successfully!`,
            );
          })
          .catch(() => {
            this.toaster.error(`Error in resetting transactions`);
          });
      })
      .catch(() => {
        this.toaster.error(`Error in resetting transactions`);
      });
  }
}
